export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 30,
  },
  title: {
    fontSize: 24,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'black',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 20,
    width: '80%',
  },
  subTitle: {
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    color: 'black',
    fontWeight: '400',
    textAlign: 'center',
    marginBottom: 20,
    width: '80%',
  },
  bodyContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    height: 36,
    marginTop: 16,
  },
  selectTitle: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    border: '1px solid #E2E2FC',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 14,
  },
  selector: {
    width: 270,
    height: 36,
    border: 'none',
    paddingRight: 6,
  },
  dateField: {
    backgroundColor: 'white',
    width: '100%',
    height: 36,
    paddingLeft: 16,
    borderRadius: 4,
    border: '1px solid #E2E2FC',
  },
  dateInput: {
    width: 270,
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 26,
    marginBottom: 20,
    width: '100%',
  },
  notEditableValue: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: "'Proxima Nova Alt', sans-serif",
    width: '52%',
    color: '#707087',
  },
  alertContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'rgba(255, 121, 141, 0.11)',
    border: '1px solid #FFA8A8',
    borderRadius: 4,
    width: '100%',
    padding: 12,
  },
  alertText: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontSize: 14,
    fontWeight: '700',
  },
  alertButton: { minWidth: 80, maxWidth: 80, fontSize: 14, height: 32 },
  alertButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '34%',
  },
  inputRoot: {
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-root': {
      width: 286,
      height: 36,
      paddingLeft: 14,
      border: '1px solid #E2E2FC',
      borderRadius: 4,
    },
  },
  datePicker: {
    marginTop: -14,
  },
  error: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'red',
    fontSize: 12,
    alignSelf: 'self-end',
    marginTop: 4,
    marginBottom: -10,
    width: 286,
  },
  dropzoneError: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'red',
    fontSize: 12,
    marginTop: 6,
  },
}
